import { render } from "./ExamImagePreAnalysis.vue?vue&type=template&id=0f515f04&scoped=true"
import script from "./ExamImagePreAnalysis.vue?vue&type=script&lang=js"
export * from "./ExamImagePreAnalysis.vue?vue&type=script&lang=js"

import "./ExamImagePreAnalysis.vue?vue&type=style&index=0&id=0f515f04&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f515f04"]])

export default __exports__